import _ from 'lodash'

import { FEATURE_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: FEATURE_MNG,
  params: null,
  formatData(data) {
    if (data.desktopArch) {
      data.desktopArch = data.desktopArch.join(',')
    }
    if (data.userRole) {
      data.userRole = data.userRole.join(',')
    }
    if (data.competitiveList) {
      data.competitive = JSON.stringify(data.competitiveList)
    }
    return data
  },
  view: {
    title: '创建功能',
    labelWidth: '200px',
    width: '700px',
    content: [
      {
        $id: 'featureName',
        $type: 'input',
        label: '功能名',
        $el: {
          placeholder: '请输入功能名',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '功能名'
          }
        ]
      },
      {
        $id: 'featureType',
        $type: 'radio-group',
        label: '售前功能类型',
        tip: {
          description: ['售前功能类型应用于售前测试项目']
        },
        $options: [
          {
            label: '推荐',
            value: 'RECOMMEND'
          },
          {
            label: '必选',
            value: 'REQUIRED'
          },
          {
            label: '可选',
            value: 'OPTIONAL'
          }
        ],
        rules: [
          {
            notEmpty: '售前功能类型'
          }
        ]
      },
      {
        $id: 'deliveryFeatureType',
        $type: 'radio-group',
        label: '交付功能类型',
        tip: {
          description: ['交付功能类型应用于交付部署项目']
        },
        $options: [
          {
            label: '推荐',
            value: 'RECOMMEND'
          },
          {
            label: '必选',
            value: 'REQUIRED'
          },
          {
            label: '可选',
            value: 'OPTIONAL'
          }
        ],
        rules: [
          {
            notEmpty: '交付功能类型'
          }
        ]
      },
      {
        $id: 'featureCategory',
        $type: 'radio-group',
        label: '功能分类',
        tip: {
          description: ['通用功能分类为云桌面产品功能，特殊功能分类为非云桌面功能，如：配置操作系统桌面壁纸']
        },
        $options: [
          {
            label: '通用',
            value: 'COMMON'
          },
          {
            label: '特殊',
            value: 'SPEC'
          }
        ],
        rules: [
          {
            notEmpty: '功能分类'
          }
        ]
      },
      {
        $id: 'desktopArch',
        $type: 'select',
        label: '适用桌面架构',
        $el: {
          clearable: true,
          filterable: true,
          multiple: true
        },
        $options: [
          {
            label: 'VDI',
            value: 'VDI'
          },
          {
            label: 'IDV',
            value: 'IDV'
          },
          {
            label: 'TCI',
            value: 'TCI'
          },
          {
            label: 'PC',
            value: 'PC'
          }
        ],
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.value,
              label: item.label
            }
          })
          if (!value) {
            return []
          }
          return Array.isArray(value) ? value : value.split(',')
        }
      },
      {
        $id: 'userRole',
        $type: 'select',
        label: '功能使用角色',
        $el: {
          clearable: true,
          filterable: true,
          multiple: true
        },
        $options: [
          {
            label: '使用者',
            value: '使用者'
          },
          {
            label: '运维者',
            value: '运维者'
          },
          {
            label: '决策者',
            value: '决策者'
          }
        ],
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.value,
              label: item.label
            }
          })
          if (!value) {
            return []
          }
          return Array.isArray(value) ? value : value.split(',')
        }
      },
      {
        $id: 'valueDesc',
        $type: 'select',
        label: '业务诉求【主打价值】',
        $el: {
          clearable: true,
          filterable: true
        },
        $options: 'featureValue/findAllActive',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.featureValue,
              label: item.featureValue
            }
          })
          if (!value) {
            return []
          }
          return value
        },
        rules: [
          {
            notEmpty: '业务诉求【主打价值】'
          }
        ]
      },
      {
        $id: 'schemeDesign',
        $type: 'input',
        label: '测试说明',
        $el: {
          placeholder: '请输入测试说明',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: '测试说明'
          }
        ]
      },
      {
        $id: 'expectedOutcome',
        $type: 'input',
        label: '预期效果',
        $el: {
          placeholder: '请输入预期效果',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: '预期效果'
          }
        ]
      },
      {
        $id: 'competitiveList',
        $type: 'sky-feature-competitive-relate',
        label: '竞争力信息'
      },
      {
        $id: 'limitDesc',
        $type: 'input',
        label: '相关限制说明',
        $el: {
          placeholder: '请输入限制',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        }
      },
      {
        $id: 'resolveIssues',
        $type: 'input',
        label: '解决客户问题',
        $el: {
          placeholder: '请输入解决的客户问题',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 5
        }
      },
      {
        $id: 'configStep',
        $type: 'input',
        $el: {
          type: 'textarea',
          rows: 5
        },
        label: '功能/方案配置步骤'
      },
      {
        $id: 'configStepLink',
        $type: 'sky-fei-shu-link',
        $el: {
          enableType: ['Docs'],
          placeholder: '请输入飞书的word 文档链接'
        },
        label: '功能配置文档'
      },
      {
        $id: 'productId',
        $type: 'select',
        label: '版本支持',
        $el: {
          clearable: true,
          filterable: true
        },
        $options: 'product/findAllActive',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.id,
              label: item.productVersion
            }
          })
          return value
        },
        rules: [
          {
            notEmpty: '版本支持'
          }
        ]
      },
      {
        $id: 'video',
        $type: 'input',
        label: '视频演示',
        $el: {
          placeholder: '请输入视频演示',
          suffixIcon: 'el-icon-edit'
        }
      },
      {
        $id: 'ppt',
        $type: 'input',
        label: 'PPT演示',
        $el: {
          placeholder: '请输入PPT演示',
          suffixIcon: 'el-icon-edit'
        }
      }
    ]
  }
}
